import api from "./api";
import i18n from "../../plugins/i18n";

export const serviceBase = {
  api: api,
  resource: "",
  preList: "me",
  preListOption: {
    getList: true
  },
  getPreList(action, params) {
    let preList = "";
    if (this.preListOption[action]) {
      if (typeof this.preList === "function") {
        preList = this.preList(params, action);
      } else {
        preList = this.preList;
      }
    }
    return preList;
  },
  getList(params = {}, onSuccess = () => {}, onError = () => {}) {
    params.filters = api.helpers.formFilters(params.filters);
    params = api.helpers.clearResource(params);
    Object.keys(params).forEach(key => !params[key] && delete params[key]);
    let preList = this.getPreList("getList", params);
    return api
      .get(`${preList ? "/" + preList : ""}/${this.resource}`, {
        params
      })
      .then(res => {
        let data = {
          list: res.data.items,
          page: res.data.page,
          cursor: res.data.cursor
        };
        onSuccess(data);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        onError(res);
      });
  },
  get(params = {}, onSuccess = () => {}, onError = () => {}) {
    let { id, ...paramsWithOutId } = params;
    params = api.helpers.clearResource(params);
    let preList = this.getPreList("get", params);
    return api
      .get(
        `${preList ? "/" + preList : ""}/${this.resource}/${id}`,
        paramsWithOutId
      )
      .then(res => {
        onSuccess(res.data);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        onError(res);
      });
  },
  create(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {},
    options = {}
  ) {
    options = {
      notify: true,
      ...options
    };

    let preList = this.getPreList("create", params);
    params = api.helpers.clearResource(params);
    return api
      .post(`${preList ? "/" + preList : ""}/${this.resource}`, params)
      .then(res => {
        options.notify && createSuccessMessage("create");
        onSuccess(res.data);
        errorHandler({});
        return res;
      })
      .catch(res => {
        options.notify && createErrorMessage(res);
        errorHandler(
          res.response && res.response.data && res.response.data.errors
        );
        onError(res);
      });
  },
  update(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {},
    options = {}
  ) {
    options = {
      notify: true,
      ...options
    };
    params = api.helpers.clearResource(params);
    let { id, ...paramsWithOutId } = params;
    let preList = this.getPreList("update", params);
    return api
      .put(
        `${preList ? "/" + preList : ""}/${this.resource}/${id}`,
        paramsWithOutId
      )
      .then(res => {
        options.notify && createSuccessMessage("update");
        onSuccess(res.data);
        errorHandler({});
        return res;
      })
      .catch(res => {
        options.notify && createErrorMessage(res);
        errorHandler(
          res.response && res.response.data && res.response.data.errors
        );
        onError(res);
      });
  },
  batchUpdate(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {},
    options = {}
  ) {
    options = {
      notify: false,
      ...options
    };
    let preList = this.getPreList("getList", params);
    return api
      .put(`${preList ? "/" + preList : ""}/${this.resource}`, {
        items: params.items
      })
      .then(res => {
        options.notify && createSuccessMessage("batch-update");
        errorHandler({});
        onSuccess(res);
      })
      .catch(res => {
        options.notify && createErrorMessage(res);
        errorHandler(
          res.response && res.response.data && res.response.data.errors
        );
        onError(res);
      });
  },
  delete(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {},
    options = {}
  ) {
    options = {
      notify: true,
      ...options
    };
    let { id, ...paramsWithOutId } = params;
    params = api.helpers.clearResource(params);
    let preList = this.getPreList("delete", params);
    return api
      .delete(
        `${preList ? "/" + preList : ""}/${this.resource}/${id}`,
        paramsWithOutId
      )
      .then(res => {
        options.notify && createSuccessMessage("delete");
        errorHandler({});
        onSuccess(res.data);
        return res;
      })
      .catch(res => {
        options.notify && createErrorMessage(res);
        errorHandler(
          res.response && res.response.data && res.response.data.errors
        );
        onError(res);
      });
  },
  deleteList(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {},
    options = {}
  ) {
    options = {
      notify: true,
      ...options
    };
    let { ids, ...paramsWithOutIds } = params;
    let preList = this.getPreList("deleteList", params);
    return api
      .delete(`${preList ? "/" + preList : ""}/${this.resource}`, {
        ids,
        ...paramsWithOutIds
      })
      .then(res => {
        options.notify && createSuccessMessage("delete-list");
        errorHandler({});
        onSuccess(res.data);
        return res;
      })
      .catch(res => {
        options.notify && createErrorMessage(res);
        errorHandler(
          res.response && res.response.data && res.response.data.errors
        );
        onError(res);
      });
  }
};
export const authorizations = function(service) {
  let change = function(params = {}, onSuccess = () => {}, mode) {
    let { id, ...paramsWithOutId } = params;
    return api
      .put(`/${service.resource}/${id}/authorizations`, paramsWithOutId)
      .then(res => {
        createSuccessMessage(`authorizations-${mode}`);
        onSuccess(res.data);
      })
      .catch(res => {
        createErrorMessage(res);
      });
  };
  return {
    getRoles: getRoles.bind(service),
    getList(params = {}, onSuccess = () => {}) {
      let { id, ...paramsWithOutId } = params;
      paramsWithOutId.limit = -1;
      return api
        .get(`/${service.resource}/${id}/authorizations`, {
          params: paramsWithOutId
        })
        .then(res => {
          onSuccess(res.data.items);
        })
        .catch(res => createErrorMessage(res));
    },

    add(params = {}, onSuccess = () => {}) {
      let _identity = params.identity;
      let _roles = params.roles.map(i => ({ id: i }));
      return change(
        {
          id: params.id,
          _identity,
          _roles
        },
        onSuccess,
        "add"
      );
    },
    setUserGroup(params = {}, onSuccess = () => {}) {
      let { id } = params;
      let _identity = params.identity;
      let _roles = params.roles.map(i => ({ id: i }));
      return api
        .put(`/${service.resource}/${id}/authorizations`, {
          id: params.id,
          _identity,
          _roles
        })
        .then(res => {
          onSuccess(res.data.items);
        })
        .catch(res => createErrorMessage(res));
    },
    deleteUserGroup(params = {}, onSuccess = () => {}) {
      let { id } = params;
      let _identity = params.identity;
      return api
        .put(`/${service.resource}/${id}/authorizations`, {
          id: params.id,
          _identity,
          _roles: []
        })
        .then(res => {
          onSuccess(res.data.items);
        })
        .catch(res => createErrorMessage(res));
    },
    editUserGroup(params = {}, onSuccess = () => {}) {
      let { id } = params;
      let _identity = params.identity;
      let _roles = params.roles.map(i => ({ id: i }));
      return api
        .put(`/${service.resource}/${id}/authorizations`, {
          id: params.id,
          _identity,
          _roles
        })
        .then(res => {
          onSuccess(res.data.items);
        })
        .catch(res => createErrorMessage(res));
    },
    edit(params = {}, onSuccess = () => {}) {
      let _identity = params.identity;
      let _roles = params.roles.map(i => ({ id: i }));
      return change(
        {
          id: params.id,
          _identity,
          _roles
        },
        onSuccess,
        "edit"
      );
    },
    delete(params = {}, onSuccess = () => {}) {
      let _identity = params.identity;
      return change(
        {
          id: params.id,
          _identity,
          _roles: []
        },
        onSuccess,
        "delete"
      );
    },
    change
  };
};

export const massOperation = function(massName) {
  return function(params = {}, onSuccess = () => {}, onError = () => {}) {
    return api
      .post(`/${this.resource}:${massName}`, params)
      .then(res => {
        createSuccessMessage(`mass-${massName}`);
        onSuccess(res);
      })
      .catch(res => {
        createErrorMessage(res);
        onError(res);
      });
  };
};

export const clearance = function(onSuccess = () => {}, onError = () => {}) {
  return api
    .post(`/clearance`)
    .then(res => {
      onSuccess(res.data.token);
      return res.data.token;
    })
    .catch(res => {
      createErrorMessage(res);
      onError(res);
    });
};

// this workaround fixes the circular dependency: service → (notification) store → service
const getStore = () => import("./../store");

export const createErrorMessage = function(res) {
  getStore().then(store => {
    store.default.dispatch(
      "notificationStore/createErrorNotificationForApiRequest",
      res
    );
  });
};
export const createSuccessMessage = function(message) {
  getStore().then(store => {
    store.default.dispatch(
      "notificationStore/createSuccessNotificationForApiRequest",
      {
        text: i18n.t(`message.success-${message}`)
      }
    );
  });
};

export const getRoles = function(onSuccess = () => {}) {
  return api
    .get(`/roles?filters=resource_type:${this.resourceRole}`)
    .then(res => onSuccess(res.data.items))
    .catch(res => createErrorMessage(res));
};

export const PredecessorsAndSuccessors = function(service) {
  return {
    getListPredecessors: function(
      par = {},
      onSuccess = () => {},
      onError = () => {}
    ) {
      let { id, ...params } = par;
      params.filters = api.helpers.formFilters(params.filters);
      params = api.helpers.clearResource(params);
      Object.keys(params).forEach(key => !params[key] && delete params[key]);
      let preList = service.getPreList("getList", params);
      return api
        .get(
          `${preList ? "/" + preList : ""}/${
            service.resource
          }/${id}/predecessors`,
          {
            params
          }
        )
        .then(res => {
          let data = { list: res.data.items, page: res.data.page };
          onSuccess(data);
          return res;
        })
        .catch(res => {
          createErrorMessage(res);
          onError(res);
        });
    },
    getListSuccessors: function(
      par = {},
      onSuccess = () => {},
      onError = () => {}
    ) {
      let { id, ...params } = par;
      params.filters = api.helpers.formFilters(params.filters);
      params = api.helpers.clearResource(params);
      Object.keys(params).forEach(key => !params[key] && delete params[key]);
      let preList = service.getPreList("getList", params);
      return api
        .get(
          `${preList ? "/" + preList : ""}/${
            service.resource
          }/${id}/successors`,
          {
            params
          }
        )
        .then(res => {
          let data = { list: res.data.items, page: res.data.page };
          onSuccess(data);
          return res;
        })
        .catch(res => {
          createErrorMessage(res);
          onError(res);
        });
    },
    createPredecessor: function(
      par = {},
      onSuccess = () => {},
      onError = () => {},
      errorHandler = () => {}
    ) {
      let { id, ...params } = par;
      let preList = service.getPreList("create", params);
      return api
        .put(
          `${preList ? "/" + preList : ""}/${
            service.resource
          }/${id}/predecessor`,
          params
        )
        .then(res => {
          createSuccessMessage("create");
          onSuccess(res.data);
          errorHandler({});
          return res;
        })
        .catch(res => {
          createErrorMessage(res);
          errorHandler(res.response.data.errors);
          onError(res);
        });
    },
    deletePredecessor(par = {}, onSuccess = () => {}, onError = () => {}) {
      let { id, ...params } = par;
      let preList = this.getPreList("delete", params);
      return api
        .delete(
          `${preList ? "/" + preList : ""}/${
            service.resource
          }/${id}/predecessor`,
          params
        )
        .then(res => {
          createSuccessMessage("delete");
          onSuccess(res.data);
          return res;
        })
        .catch(res => {
          createErrorMessage(res);
          onError(res);
        });
    }
  };
};
